import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "./footer";
import PatientsList from "../pages/hcp/patients_list";
import { FaBars } from "react-icons/fa";
import { BiChevronDown } from "react-icons/bi";
import PatientHomePage from "../pages/hcp/patients_home_page";
import { Redirect, Route, Switch } from "react-router-dom";
import FunctionalScore from "../pages/hcp/functional_score";
import CareManagement from "../pages/hcp/care_management";
import ReviewCarePlan from "../pages/hcp/review_care_plan";
import CarePlanSummaries from "../pages/hcp/care_plan_summaries";
import WeekConference from "../pages/hcp/week_conference";
import ReviewFunctionalEntry from "../pages/hcp/review_functional_entry";
import FunctionalSummaries from "../pages/hcp/functional_summaries";
import OutstandingList from "../pages/hcp/outstanding_document_list";
import { logOut } from "../services/auth_service";
import PatientHome from "../pages/patient/patient_home";
import PatientFunction from "../pages/patient/patient_function";
import UserProfileLayout from "../layout/UserProfileLayout";
import GetPatient from "../hooks/getPatient";
import CreateAssessmentNotes from "../pages/hcp/create_assessment_notes";
import AssessmentNotes from "../pages/hcp/assessment_notes";
import FunctionalSummariesGraph from "../pages/hcp/functional_summaries_graph";
import PatientsOutstandingDocuments from "../pages/hcp/patients_outstanding_document_list";
import { useAuth } from "../services/authProvider";
import GetSinglePatient from "../hooks/getSinglePatientProfile";
import moment from "moment";
import FunctionalSummariesTeamScore from "../pages/hcp/functional_summaries_team_score";
import { useUserProfile } from "../hooks/getUserProfile";
import { logoutWithWarning } from "../utils/logoutWithWarning";
import PermissionProtectedRoute from "./common/PermissionProtectedRoute";
import { PERMISSIONS, getActiveOrganization } from "../utils/permissions";
import Unauthorized from "../pages/Unauthorized";

const Main = ({ handleCollapsedChange, page }) => {
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem("user"));
  const { data: userProfile, isLoading } = useUserProfile();
  const [patient, setPatient] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const organizationName = getActiveOrganization()?.name;
  useEffect(() => {
    const localPatient = JSON.parse(localStorage.getItem("localPatient"));
    if (localPatient) {
      setPatient(localPatient);
    }
  }, [page]);

  // Handle dropdown toggle
  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownOpen && !event.target.closest(".dropdown")) {
        setDropdownOpen(false);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && dropdownOpen) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("click", handleClickOutside);
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [dropdownOpen]);

  // Handle dropdown item click
  const handleDropdownItemClick = () => {
    setDropdownOpen(false);
  };

  return (
    <main className="h-100">
      <nav className="navbar navbar-expand-lg navbar-white bg-white shadow-sm pr-4 py-4">
        <span>
          {/* <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
                <FaBars />
            </div> */}
          <button className="btn " onClick={handleCollapsedChange}>
            <FaBars />
          </button>
          {page !== "patient" && patient && (
            <>
              <span className="text_small">
                {patient.lastName}, {patient.firstName}
              </span>
              <span className="text_small pl-2">{patient.age}</span>
              <span className="text_small pl-2">
                ({patient.gender == "F" ? "Female" : "Male"})
              </span>
              <span className="text_small pl-2">
                {moment(patient.dob).format("DD MMM YYYY")}
              </span>
              {/* <span className="text_small pl-2">
                ID: {patient.pomme_id} Location
              </span> */}
              <span className="text_small pl-2">OHIP: {patient.ohip}</span>
            </>
          )}
        </span>
        {/* {organizationName && (
          <div className="d-none d-md-flex align-items-center ml-3">
            <span className="navbar-org-name text_small">
              {organizationName}
            </span>
          </div>
        )} */}
        <div className="navbar-nav ml-auto d-flex align-items-center">
          <ul className="navbar-nav">
            <li className={`nav-item dropdown ${dropdownOpen ? "show" : ""}`}>
              <a
                className="navbar-btn px-2 rounded d-flex align-items-center justify-content-center text_small text-decoration-none"
                href="#"
                id="navbarDropdown"
                role="button"
                aria-expanded={dropdownOpen}
                onClick={toggleDropdown}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleDropdown(e);
                  }
                }}
              >
                <div className="d-flex flex-column align-items-start mr-2">
                  <span>
                    {userProfile?.data.lastName}, {userProfile?.data.firstName}
                  </span>
                  <span>
                    {userProfile?.data.careProvider
                      ? userProfile?.data.careProvider.position.abbreviation
                      : ""}
                  </span>
                </div>
                <BiChevronDown size={30} className="navbar-btn-icon" />
              </a>
              <div
                className={`dropdown-menu w-small dropdown-menu-right pl-0 ml-0 ${
                  dropdownOpen ? "show" : ""
                }`}
                aria-labelledby="navbarDropdown"
              >
                <Link
                  className="dropdown-item ml-0 pl-3 text_small"
                  to={
                    user?.organizations[0].role === "HEALTH_CARE_PROVIDER"
                      ? "/hcp/profile/personal_details"
                      : "/patient/profile/personal_details"
                  }
                  onClick={handleDropdownItemClick}
                >
                  <i className="fa fa-user" /> &nbsp;Profile
                </Link>
                <Link
                  className="dropdown-item ml-0 pl-3 text_small"
                  to={
                    user?.organizations[0].role === "HEALTH_CARE_PROVIDER"
                      ? "/hcp/profile/change_password"
                      : "/patient/profile/change_password"
                  }
                  onClick={handleDropdownItemClick}
                >
                  <i className="fa fa-key" /> &nbsp;Change Password
                </Link>
                <div
                  className="dropdown-item ml-0 pl-3 text_small cursor-pointer"
                  onClick={() => {
                    handleDropdownItemClick();
                    logoutWithWarning(logout);
                  }}
                >
                  <i className="fa fa-sign-out" /> &nbsp;Logout
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <Switch>
        <Route path="/hcp/patient/unauthorized" component={Unauthorized} />
        <Route path="/hcp/patient/details/:id" component={PatientHomePage} />

        {/* Care Plan Routes - Protected by CREATE_CAREPLAN permission */}
        <PermissionProtectedRoute
          path="/hcp/patient/care_review_plan"
          component={ReviewCarePlan}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.CREATE_CAREPLAN}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/care_management"
          component={CareManagement}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.CREATE_CAREPLAN}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/plan_care_summaries"
          component={CarePlanSummaries}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.READ_CAREPLAN}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/weekly_conference"
          component={WeekConference}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.READ_CAREPLAN}
        />

        {/* Functional Score Routes - Protected by functional score permissions */}
        <PermissionProtectedRoute
          path="/hcp/patient/function_score"
          component={FunctionalScore}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.CREATE_FUNCTIONAL_SCORE}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/function_review_entry"
          component={ReviewFunctionalEntry}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.CREATE_FUNCTIONAL_SCORE}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/summary_functions"
          component={FunctionalSummaries}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.READ_FUNCTIONAL_SCORE}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/team_score_functional_summaries"
          component={FunctionalSummariesTeamScore}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.READ_FUNCTIONAL_SCORE}
        />
        <PermissionProtectedRoute
          path="/hcp/patient/summary_functions_graph"
          component={FunctionalSummariesGraph}
          allowedRoles={["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"]}
          requiredPermission={PERMISSIONS.READ_FUNCTIONAL_SCORE}
        />

        {/* Assessment Notes Routes */}
        <Route
          path="/hcp/patient/create/assessment_notes"
          component={CreateAssessmentNotes}
        />
        <Route
          path="/hcp/patient/assessment_notes"
          component={AssessmentNotes}
        />

        {/* Other HCP Routes */}
        <Route path="/hcp/patient/list" component={PatientsList} />
        <Route path="/hcp/outstanding_documents" component={OutstandingList} />
        <Route path="/hcp/profile" component={UserProfileLayout} />

        {/* Patient Routes */}
        <Route path="/patient/home" component={PatientHome} />
        <Route path="/patient/enter_function" component={PatientFunction} />
        <Redirect from="/patient" to={"/patient/home"} />
        <Redirect
          from="/hcp"
          to={page !== "patient" ? "/hcp/patient/list" : "/patient/home"}
        />
      </Switch>
    </main>
  );
};

export default Main;
